import { createRouter, createWebHistory } from "vue-router";
import defaultRoutes from "@/router/default";
import baseRoutes from "@/router/base";
import middlewares from "@/router/middleware";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...defaultRoutes, ...baseRoutes],
});

/*router.beforeEach(async (to, from) => {
    if (!token.length && to.name !== 'login' && to.name !== 'ekyzmat') {
        return {name: 'login'}
    }
})*/

router.beforeEach((to, from, next) => {
  for (const [, callback] of Object.entries(middlewares)) {
    const result = callback(to, from, next);
    if (result !== false) return result;
  }

  return next();
});

export default router;
